import BreadCrumb from "Components/Common/BreadCrumb";
import MembersTable from "Components/Settings/TeamMembers/MembersTable";
import { Container } from "reactstrap";

const TeamMembers = () => {
  document.title = "Team Members | EaziQuote";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Team Members" pageTitle="Settings" url="/settings" />
        <MembersTable />
      </Container>
    </div>
  );
};

export default TeamMembers;
